export const features = {
  STUDENT_EVENT_TRACKING: 'feature.communities-student-event-tracking',
  COURSES_TO_COMMUNITIES: 'feature.courses-to-communities-link',
  NOTIFICATION_PANE: 'feature.notification-pane',
  COMMUNITIES_TRENDING_POSTS: 'feature.communities-trending-posts',
  COMMUNITIES_AS_A_PRODUCT: 'feature.communities-as-a-product',
  DEV_COMMUNITIES_DEBUGGING: 'dev-communities-debugging',
  COMMUNITIES_EVENTS_RSVP: 'feature.communities-events-rsvp',
  COMMUNITIES_EVENT_EMAILS: 'feature.live-event-emails',
  COMMUNITIES_MEMBERS_PAGE: 'communities-members-page-temp-nov-18-2022',
  EXCLUSIVE_SPACES: 'feature.community-exclusive-spaces',
};
